export default {
  baseStyle: {
    requiredText: {
      color: '#232323'
    },
    helperText: {
      _groupDisabled: {
        color: 'grey.850'
      }
    }
  }
};